import Rollbar, { LogArgument } from "rollbar";

import config from "./config";
import { Identity } from "./shared/domain";
import { xCorrelationIdProvider } from "./shared/hooks/useAuth/providers";

let rollbar: Rollbar = null;

export const init = (): void => {
    const xCorrelationId = xCorrelationIdProvider.getXCorrelationId();
    // Rollbar
    const rollbarConfig = {
        accessToken: config.ROLLBAR_ACCESS_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: true,
        scrubFields: ["password", "newPassword", "sc"],
        enabled: !!config.ROLLBAR_ACCESS_TOKEN,
        checkIgnore(_isUncaught: boolean, _args: LogArgument[] /* , item: object */): boolean {
            return false;
        },
        ignoredMessages: [
            "Token expired",
            "not authenticated",
            "Registration email cannot be validated twice. [410]",
            "Password invalid [400]",
        ],
        payload: {
            environment: config.ENV,
            client: {
                javascript: {
                    source_map_enabled: true,
                    code_version: config.BUILD.COMMIT_HASH,
                    guess_uncaught_frames: true,
                },
            },
            person: { id: "", xCorrelationId },
        },
    };
    rollbar = new Rollbar(rollbarConfig);
};

export const setIdentity = (identity: Identity): void => {
    const xCorrelationId = xCorrelationIdProvider.getXCorrelationId();
    if (!rollbar) {
        return;
    }
    if (!identity.isAuthenticated) {
        rollbar.configure({
            payload: { person: { id: "", xCorrelationId } },
        });

        return;
    }

    rollbar.configure({
        payload: {
            person: {
                id: identity.id,
                broker: identity.currentBrokerId,
                xCorrelationId,
            },
        },
    });
};

export const logError = (key: string, error: Error): void => {
    if (rollbar) {
        rollbar.error(key, error);
    }
};

export const logWarning = (key: string, error: Error): void => {
    if (rollbar) {
        rollbar.warning(key, error);
    }
};
